import { render } from "./CreateAppStore.vue?vue&type=template&id=63fb21b8"
import script from "./CreateAppStore.vue?vue&type=script&lang=js"
export * from "./CreateAppStore.vue?vue&type=script&lang=js"

import exportComponent from "/Users/davidchou/Documents/Programming/vue/cvicloud-app-states-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__